import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { HardwareOpsPage } from "@/features/hardware-ops";
import { hardwareSearchSchema } from "@/features/hardware-ops/hardware-route-search";

/** `?serial=` deep-links a row's detail drawer, mirroring `/users?userId=`. */
export const Route = createFileRoute("/hardware/")({
  validateSearch: hardwareSearchSchema,
  component: HardwareRoute,
});

function HardwareRoute() {
  return (
    <AdminDashboardShell>
      <HardwareOpsPage />
    </AdminDashboardShell>
  );
}
